
<template>
  <div class="auth-buttons d-flex align-items-center">
    <!-- Desktop buttons -->
    <div class="desktop-auth-buttons d-none d-md-flex align-items-center">
      <button
        type="button"
        class="btn btn-outline-primary me-2"
        data-bs-toggle="modal"
        data-bs-target="#authModal"
        @click="setModalTab('login')"
      >
        Accedi
      </button>
      <button
        type="button"
        class="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#authModal"
        @click="setModalTab('register')"
      >
        Registrati
      </button>
    </div>

    <!-- Mobile user placeholder -->
    <div class="mobile-auth-placeholder d-md-none">
      <div
        class="d-flex align-items-center bg-transparent border-0 text-start p-0 cursor"
        data-bs-toggle="modal"
        data-bs-target="#authModal"
        @click="setModalTab('login')"
      >
        <div class="flex-shrink-0">
          <span class="rounded-circle wh-40 d-flex align-items-center justify-content-center bg-secondary text-white fs-20">
            <i class="material-symbols-outlined">person</i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AuthButtons',
  setup() {
    const setModalTab = (tab: 'login' | 'register') => {
      // Invia evento personalizzato per impostare il tab
      const event = new CustomEvent('setAuthModalTab', { 
        detail: { tab } 
      });
      window.dispatchEvent(event);
    };

    return {
      setModalTab
    };
  }
});
</script>

<style scoped>
.auth-buttons {
  gap: 8px;
}

.mobile-auth-placeholder {
  cursor: pointer;
}

.mobile-auth-placeholder .cursor {
  cursor: pointer;
}

.mobile-auth-placeholder:hover .bg-secondary {
  background-color: var(--bs-primary) !important;
}
</style>
